import PUWClaimDetailsView from 'text!customerEdge/fnol/puw/views/puw-claim-details.html';
import PUWMoreInfoView from 'text!customerEdge/fnol/puw/views/puw-more-info.html';
import PUWMainContactView from 'text!customerEdge/fnol/puw/views/puw-main-contact.html';
import PUWSummaryView from 'text!customerEdge/fnol/puw/views/puw-summary.html';

import PUWBaseFnolWizardCtrl from 'customerEdge/fnol/puw/controllers/PUWBaseFnolWizardCtrl';
import PUWClaimDetailsCtrl from 'customerEdge/fnol/puw/controllers/PUWClaimDetailsCtrl';
import PUWMainContactCtrl from 'customerEdge/fnol/puw/controllers/PUWMainContactCtrl';
import PUWMoreInfoCtrl from 'customerEdge/fnol/puw/controllers/PUWMoreInfoCtrl';
import PUWSummaryCtrl from 'customerEdge/fnol/puw/controllers/PUWSummaryCtrl';

export default function () {

    const puwBaseFnolWizard = {
        name: 'puwBaseFnolWizard',
        parent: 'baseFnolWizard',
        abstract: true,
        controller: PUWBaseFnolWizardCtrl,
        template: '<div ui-view></div>',
        data: {
            trackingUrl: ''
        }
    };

    return {
        puwBaseFnolWizard: puwBaseFnolWizard,

        puwClaimDetails: {
            name: 'puwClaimDetails',
            parent: puwBaseFnolWizard,
            template: PUWClaimDetailsView,
            controller: PUWClaimDetailsCtrl
        },
        puwMoreInfo: {
            name: 'puwMoreInfo',
            parent: puwBaseFnolWizard,
            controller: PUWMoreInfoCtrl,
            template: PUWMoreInfoView
        },
        puwMainContact: {
            name: 'puwMainContact',
            parent: puwBaseFnolWizard,
            template: PUWMainContactView,
            controller: PUWMainContactCtrl
        },
        puwFnolSummary: {
            name: 'puwFnolSummary',
            parent: puwBaseFnolWizard,
            template: PUWSummaryView,
            controller: PUWSummaryCtrl
        }
    };
}
